export default "__VITE_ASSET__BLOcbcT2__"